import { toast } from "react-toastify";
import axios from "../../../configAxios";

// Production runs the QuickBooks OAuth 2 flow on the FAVA API host, where the
// Intuit redirect URI is registered. Elsewhere (staging, local) it runs on the
// API host itself, which also signs the link token.
export const quickbooksHost = () => {
  const origin = new URL(axios.defaults.baseURL).origin;
  return origin.endsWith(".amsnetwork.app") ? "https://fava.amsnetwork.app" : origin;
};

const failed = message => toast.error(message);

// Opens the pop-up at once (a pop-up opened after a network call is blocked),
// then asks the API for the signed, short-lived path that starts the link for
// the current organization (sc-38079), and sends the pop-up there.
export const startQuickbooksLink = () => {
  const popup = window.open("", "QuickBookOAuth", "width=1080, height=720");
  if (!popup) {
    failed("Allow pop-ups for this site to link QuickBooks.");
    return Promise.resolve();
  }
  return axios
    .get("/quickbooks/oauth2_link")
    .then(res => {
      const path = res && res.data && res.data.path;
      if (!path) throw new Error("No QuickBooks link path");
      // The user closed the pop-up while waiting: do nothing.
      if (popup.closed) return;
      popup.location.href = quickbooksHost() + path;
    })
    .catch(() => {
      popup.close();
      failed("Could not start the QuickBooks link. Please try again.");
    });
};
